import { useState } from "react";
import { toast } from "@/components/ui/notify";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { usePauseRun } from "@/features/production/hooks";
import { getFriendlyErrorMessage } from "@/lib/api-client";

interface PauseObsFormProps {
  lineId: string;
  runId: string;
  onDone: () => void;
}

export function PauseObsForm({ lineId, runId, onDone }: PauseObsFormProps) {
  const [observation, setObservation] = useState("");
  const pauseRun = usePauseRun(lineId);

  async function submit() {
    try {
      await pauseRun.mutateAsync({
        runId,
        observation: observation.trim() || undefined,
      });
      toast.success("Produção pausada.");
      onDone();
    } catch (err) {
      toast.error("Falha ao pausar.", {
        description: getFriendlyErrorMessage(err),
      });
    }
  }

  return (
    <div className="space-y-2 rounded border bg-background p-2">
      <Label htmlFor="op-obs" className="text-xs">
        Observação (opcional)
      </Label>
      <Input
        id="op-obs"
        value={observation}
        onChange={(e) => setObservation(e.target.value)}
        maxLength={1000}
      />
      <div className="flex gap-1.5">
        <Button
          size="sm"
          className="flex-1"
          onClick={() => void submit()}
          disabled={pauseRun.isPending}
        >
          {pauseRun.isPending ? "Pausando…" : "Pausar agora"}
        </Button>
        <Button size="sm" variant="ghost" onClick={onDone}>
          Cancelar
        </Button>
      </div>
    </div>
  );
}
